// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/breakpoint.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bYiQhCz4purOhvvz7NSQ {
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
  border-radius: 5px;
  padding: 16px;

  display: grid;
  grid-template-columns: repeat(2, 1fr);

  max-width: 750px;
  margin-bottom: 16px;
}

.bYiQhCz4purOhvvz7NSQ p {
  margin: 8px 0;
}

.C6WClTVhk6ITfyGGZN29 {
  font-weight: 500;
}

.gEtOb4tIeGa4w94PcVio { width: 100% }

.tuGCzJ50uwApvqqRTTNe {
  display: flex;
  align-items: center;
  margin-top: 8px;
  text-decoration: none;
  font-weight: 500;
}

.tuGCzJ50uwApvqqRTTNe .Qn5uxZUuWAeIMQzcxJqe {
  margin-right: 4px;
}

.xWPN9rRHGw3beVYOr4eR {
  padding-bottom: 2rem;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet"]}) {
  .bYiQhCz4purOhvvz7NSQ {
    grid-template-columns: repeat(1, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Payements/PayementsForm/Transfer/Transfer.module.css"],"names":[],"mappings":"AAOA;EACE,8DAA4B;EAC5B,kBAAkB;EAClB,aAAa;;EAEb,aAAa;EACb,qCAAqC;;EAErC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAU,YAAY;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-text-subtle from colors;\n\n@value breakpoints: \"components/library/style/breakpoint.css\";\n@value desktop, laptop, tablet-l, tablet, mobile, mobile-xs from breakpoints;\n\n\n.grid {\n  border: 1px solid color-gray;\n  border-radius: 5px;\n  padding: 16px;\n\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n\n  max-width: 750px;\n  margin-bottom: 16px;\n}\n\n.grid p {\n  margin: 8px 0;\n}\n\n.text {\n  font-weight: 500;\n}\n\n.submit { width: 100% }\n\n.download {\n  display: flex;\n  align-items: center;\n  margin-top: 8px;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.download .icon {\n  margin-right: 4px;\n}\n\n.transfer {\n  padding-bottom: 2rem;\n}\n\n@media screen and (max-width: tablet) {\n  .grid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"breakpoints": `"components/library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["desktop"]}`,
	"laptop": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["laptop"]}`,
	"tablet-l": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet-l"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["mobile"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["mobile-xs"]}`,
	"grid": `bYiQhCz4purOhvvz7NSQ`,
	"text": `C6WClTVhk6ITfyGGZN29`,
	"submit": `gEtOb4tIeGa4w94PcVio`,
	"download": `tuGCzJ50uwApvqqRTTNe`,
	"icon": `Qn5uxZUuWAeIMQzcxJqe`,
	"transfer": `xWPN9rRHGw3beVYOr4eR`
};
export default ___CSS_LOADER_EXPORT___;
